// Third-party imports
import Aos from 'aos';

// AW component imports
import Animate from './animate';
import Menu from './components/menu-custom';
import injectRegistrationScripts, { injectOtherScripts } from './helpers/registrationScripts';

// import AdBubble from './components/ad-bubble';
// import toggleCovidBanner from './components/covid-banner';
import toggleCookieBanner from './components/cookie-banner';
import adBanner from './components/ad-banner';

import { getCookieValue } from './helpers/cookie';

class Site {
  constructor() {
    this.body = document.body;
    this.breakpoint = {};

    this.animate = new Animate();
    this.menu = new Menu();
    this.bind();
    this.resize();
  }


  init() {
    // onScroll animations init
    Aos.init({ offset: 40 });

    this.setAsLoaded();
    // this.bubble = new AdBubble();
  }


  setAsLoaded() {
    // this.body.classList.remove('loading');
    const documentBody = this.body;
    if (!documentBody.classList.contains('is-loaded')) {
      this.body.classList.add('is-loaded');
    }
  }


  updateBreakpoint() {
    this.breakpoint = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '');
  }

  static injectOnView() {
    if (window.pageYOffset >= 300) {
      if (!window.siteInfo.isregistered || window.location.pathname === '/ca/integrations') {
        injectRegistrationScripts();
      }
      injectOtherScripts();
    }
  }


  bind() {
    window.addEventListener('resize', () => this.resize());
  }


  resize() {
    // things to update onResize
    this.updateBreakpoint();
    // this.menu.resize();
  }
}

window.addEventListener('pageshow', () => {
  const leadRegistrationFold = document.getElementById('registration');
  if (getCookieValue('isregistered') && leadRegistrationFold) {
    leadRegistrationFold.classList.add('d-none');
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const AWsite = new Site();
  AWsite.init();
  // toggleCovidBanner();
  toggleCookieBanner();
  adBanner();
  Site.injectOnView();
});

document.addEventListener('scroll', () => {
  Site.injectOnView();
});
